import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  clearResults,
  selectCommon,
  setFusionOneUserData,
  setUserData
} from '../common/services/common.service';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDataToLocalStore } from 'src/auth/RBAC/utils';
import { goToRoute } from 'src/auth/login/Utils';
import { useAuth } from 'src/providers/AuthguardContext';
import { BASEPATH } from 'src/shared/constants/routes';
import { getRouteFromFusion1Url } from 'src/shared/constants/constants';


const ReceiveTokenModule = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { userData } = useSelector(selectCommon);
  const { login } = useAuth();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const fusion1Url = queryParams.get('fusion1');

  const handleMessage = async (event) => {
    console.log(' event.origin', event.origin);
    if (
      event.origin !== process.env.REACT_APP_FUSION_ONE_DOMAIN_URL ||
      !event?.data?.data?.accessToken
    ) {
      console.log('unauthorized origin or accessToken', event.origin);
      return;
    }

    try {
      const { accessToken, userId, onboardingStatus } = event?.data?.data;
      console.log('event?.data?.data:::', event?.data?.data);
      const payload = {
        token: accessToken,
        onboardingStatus: onboardingStatus,
        userUid: userId
      };
      console.log('payload', payload);
      setTimeout(async () => {
        const newUserData = await setUserDataToLocalStore(
          payload,
          !!fusion1Url
        );
        await dispatch(setUserData(newUserData));
      }, 1000);
    } catch (error) {
      console.error('error', error);
    }
    //}
  };

  useEffect(() => {
    // Listen for postMessage events

    window.addEventListener('message', handleMessage);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    dispatch(clearResults());
    localStorage.clear();
  }, []);

  // In ReceiveTokenModule.tsx
  useEffect(() => {
    if (!Object.keys(userData).length || !userData?.accessToken) {
      return;
    }

    const navigateToPath = async () => {
      try {
        await login(userData);
        console.log('fusion1Url', fusion1Url);
        if (fusion1Url) {
          const targetRoute = getRouteFromFusion1Url(fusion1Url);
          console.log('targetRoute', targetRoute);
          if (targetRoute) {
            // Store the fusion1Url value in Redux for tracking
            dispatch(setFusionOneUserData(fusion1Url));
            // Navigate to the dynamically determined route
            navigate(`/${BASEPATH}/${targetRoute}`, { replace: true });
          } else {
            // If fusion1Url doesn't match any known route, log warning and fallback to default
            console.warn(
              `Unknown fusion1Url value: "${fusion1Url}". Falling back to default route.`
            );
            const route = goToRoute(userData);
            navigate(`/${route}`, { replace: true });
          }
        } else {
          // No fusion1Url parameter, use default routing logic
          const route = goToRoute(userData);
          navigate(`/${route}`, { replace: true });
        }
      } catch (error) {
        console.error('Navigation error:', error);
      }
    };

    const timeout = setTimeout(() => {
      navigateToPath();
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [userData]);

  return (
    <Box className="spinnerWrapper flex-basic-center mt-100 mb-100 ">
      <Box className="spinnerLoading "></Box>
    </Box>
  );
};

export default ReceiveTokenModule;
